var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.642 2.667c2.674 0 3.644.278 4.622.801a5.45 5.45 0 012.268 2.268c.523.978.801 1.948.801 4.622v11.284c0 2.674-.278 3.644-.801 4.622a5.45 5.45 0 01-2.268 2.268c-.978.523-1.948.801-4.622.801H20.05v-10.09h3.163l.476-3.673H20.05v-2.337c0-1.06.297-1.782 1.816-1.782h1.925V8.174c-.333-.046-1.484-.143-2.825-.143-2.796 0-4.71 1.707-4.71 4.84v2.705h-3.15v3.672h3.15v10.085h-5.899c-2.674 0-3.644-.278-4.622-.801a5.45 5.45 0 01-2.268-2.268c-.523-.978-.801-1.948-.801-4.622V10.358c0-2.674.278-3.644.801-4.622a5.45 5.45 0 012.268-2.268c.978-.523 1.948-.801 4.622-.801h11.284z","fillRule":"nonzero"}));
}

Facebook.defaultProps = {"width":"32","height":"32"};

module.exports = Facebook;

Facebook.default = Facebook;
